import React from "react";
import {connect} from "react-redux";
import createReactClass from 'create-react-class';
import {Button} from "react-bootstrap";
import {URLs} from "../../common/constants";
import {redirectPage} from '../../common/utils';
import {AccountModes} from "../../common/constants";
import {translate} from '../../i18n/translate.js';

const AccountSummaryManagePayments = createReactClass( {
    onManage() {
        let url = redirectPage(URLs.PAY, this.props.staticData) + "?source=account";
        if (this.props.isPreview && this.props.memberKey)
            url += "&mode=preview&m=" + this.props.memberKey;
        window.location.assign(url);
    },
    allowManagePayments() {
        return this.props.mode === AccountModes.VIEW &&
            ((this.props.singlePaymentPlans||{}).length > 0 &&
            this.props.singlePaymentMethods && this.props.singlePaymentMethods.length > 0) ||
            (!this.props.hasToken && this.props.autoPaymentMethods && this.props.autoPaymentMethods.length > 0 &&
            (this.props.autoPaymentPlans||{}).length > 0 ) ||
            (this.props.hasToken && this.props.autoPaymentMethods && this.props.autoPaymentMethods.length > 0);
    },
    render() {
        const label = this.props.clientViewPort.isXs ? translate("Payments") : translate("Manage Payments");
        return (
            <Button bsStyle="primary" className="manage-payments-btn button" onClick={this.onManage}>{label}</Button>
        )
    }
});

const mapStateToProps =  (state) =>  {
    const account = state.account || {};
    const subscriptionSummary = state.summary || {};
    return {
        clientViewPort: (state.clientViewPort || {}),
        mode: account.mode,
        isPreview: (state.staticData || {}).isPreview,
        memberKey: (state.memberDetails || {}).key,
        staticData: state.staticData,
        singlePaymentPlans: subscriptionSummary.singlePaymentPlans,
        autoPaymentPlans: subscriptionSummary.autoPaymentPlans,
        singlePaymentMethods: subscriptionSummary.singlePaymentMethods,
        autoPaymentMethods: subscriptionSummary.autoPaymentMethods
    };
};

export default connect(mapStateToProps, null) (AccountSummaryManagePayments);




// WEBPACK FOOTER //
// ./src/containers/account/AccountSummaryManagePayments.js